import ServiceTemplate from '@/components/ServiceTemplate';

export default function OwnershipTransfers() {
  const data = {
    title: 'Trademark Ownership Transfer Services',
    subtitle: 'Professional trademark assignment and transfer services for seamless ownership changes.',
    overviewTitle: 'Understanding Trademark Transfers',
    overviewImage: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c',
    description: [
      'Trademark ownership transfers occur during business sales, mergers, asset purchases, or internal restructuring. Proper documentation and USPTO recording are essential to maintain trademark rights and enforceability.',
      'Our comprehensive transfer service ensures all assignments are properly documented, executed, and recorded with the USPTO. We handle the entire process from drafting assignment agreements to updating official records.',
      'Whether transferring a single mark or an entire trademark portfolio, we ensure seamless transitions that protect value and maintain continuous trademark protection.'
    ],
    benefits: [
      { title: 'Legal Compliance', description: 'Ensure all transfers comply with trademark law requirements.' },
      { title: 'Complete Documentation', description: 'Properly drafted and executed assignment agreements.' },
      { title: 'USPTO Recording', description: 'Official recording with the USPTO for public record.' },
      { title: 'Chain of Title', description: 'Maintain clear ownership records and chain of title.' },
      { title: 'Due Diligence', description: 'Review and verify trademark status before transfer.' },
      { title: 'Portfolio Management', description: 'Handle multiple trademark transfers efficiently.' }
    ],
    process: [
      { title: 'Transfer Planning & Documentation', description: 'Review requirements and prepare comprehensive transfer agreements and documents.' },
      { title: 'Execution & Verification', description: 'Coordinate proper execution, notarization, and verification of all transfer documents.' },
      { title: 'Recording & Compliance', description: 'File and record transfers with appropriate authorities and ensure ongoing compliance.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential trademark filing',
        price: '$599',
        period: '+ USPTO fees ($250-$350)',
        features: [
          'Preliminary trademark search',
          'Single class filing',
          'USPTO application preparation',
          'Filing with USPTO',
          'Email support',
          'Status monitoring'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete trademark package',
        price: '$999',
        period: '+ USPTO fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Comprehensive search report',
          'Multi-class discounts available',
          'Office action response (1 included)',
          'Priority processing',
          'Trademark monitoring (6 months)',
          'Phone & email support'
        ]
      },
      {
        name: 'Premium',
        description: 'Full-service trademark protection',
        price: '$1,499',
        period: '+ USPTO fees',
        features: [
          'Everything in Professional',
          'Global trademark search',
          'Unlimited office action responses',
          'International filing coordination',
          'Trademark monitoring (12 months)',
          'Enforcement support',
          'Dedicated attorney access'
        ]
      }
    ],
    faqs: [
      { question: 'When should a trademark transfer be recorded?', answer: 'Assignments should be recorded with the USPTO within three months of execution to ensure proper chain of title and priority.' },
      { question: 'What documents are needed?', answer: 'Typically requires a signed assignment agreement, proof of execution, and information about both transferor and transferee.' },
      { question: 'How long does recording take?', answer: 'USPTO recording typically takes 3-6 months, though the transfer is effective upon execution of the assignment agreement.' },
      { question: 'Can I transfer part of a trademark?', answer: 'Trademarks must be transferred with associated goodwill. Partial transfers require careful structuring to maintain trademark validity.' },
      { question: 'What about pending applications?', answer: 'Pending applications can be assigned, and recording ensures the new owner receives all rights upon registration.' },
      { question: 'Do I need to transfer related trademarks together?', answer: 'Related marks in the same family should generally be transferred together to avoid consumer confusion and maintain trademark strength.' },
      { question: 'What is goodwill in trademark transfers?', answer: 'Goodwill is the reputation and customer recognition associated with the trademark. Transfers must include goodwill to remain valid.' },
      { question: 'Can assignments be reversed?', answer: 'Once properly executed and recorded, assignments are permanent. Any reversal would require a new assignment back to the original owner.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
